import { ISubject } from "../../../core/models/subject";

export const disciplines = [
  {
    label: 'Biologia',
    slug: 'biologia',
    link: '/disciplinas/biologia',
  },
  {
    label: 'Química',
    slug: 'quimica',
    link: '/disciplinas/quimica',
  },
  {
    label: 'Física',
    slug: 'fisica',
    link: '/disciplinas/fisica',
  },
  {
    label: 'Matemática',
    slug: 'matematica',
    link: '/disciplinas/matematica',
  },
  {
    label: 'História',
    slug: 'historia',
    link: '/disciplinas/historia',
  },
  {
    label: 'Geografia',
    slug: 'geografia',
    link: '/disciplinas/geografia',
  },
  {
    label: 'Atualidades',
    slug: 'atualidades',
    link: '/disciplinas/atualidades',
  },
  {
    label: 'Filosofia',
    slug: 'filosofia',
    link: '/disciplinas/filosofia',
  },
  {
    label: 'Sociologia',
    slug: 'sociologia',
    link: '/disciplinas/sociologia',
  },
  {
    label: 'Português',
    slug: 'portugues',
    link: '/disciplinas/portugues',
  },
  {
    label: 'Literatura',
    slug: 'literatura',
    link: '/disciplinas/literatura',
  },
  {
    label: 'Redação',
    slug: 'redacao',
    link: '/disciplinas/redacao',
  },
  {
    label: 'Inglês',
    slug: 'ingles',
    link: '/disciplinas/ingles',
  },
  {
    label: 'Espanhol',
    slug: 'espanhol',
    link: '/disciplinas/espanhol',
  },
  {
    label: 'Interdisciplinar',
    slug: 'interdisciplinar',
    link: '/disciplinas/interdisciplinar',
  },
];

export const universityDisciplines = [
  {
    label: 'Bioquímica',
    slug: 'bioquimica-superior',
    link: '/disciplinas/bioquimica-superior',
  },
  {
    label: 'Anatomia Humana',
    slug: 'anatomia-superior',
    link: '/disciplinas/anatomia-superior',
  },
  {
    label: 'Histologia Humana',
    slug: 'histologia-humana-superior',
    link: '/disciplinas/histologia-humana-superior',
  },
  {
    label: 'Fisiologia Humana',
    slug: 'fisiologia-superior',
    link: '/disciplinas/fisiologia-superior',
  },
  {
    label: 'Genética',
    slug: 'genetica-superior',
    link: '/disciplinas/genetica-superior',
  },
  {
    label: 'Embriologia',
    slug: 'embriologia-superior',
    link: '/disciplinas/embriologia-superior',
  },
  {
    label: 'Imunologia',
    slug: 'imunologia-superior',
    link: '/disciplinas/imunologia-superior',
  },
  {
    label: 'Microbiologia',
    slug: 'microbiologia-superior',
    link: '/disciplinas/microbiologia-superior',
  },
  {
    label: 'Parasitologia',
    slug: 'parasitologia-superior',
    link: '/disciplinas/parasitologia-superior',
  },
  {
    label: 'Patologia',
    slug: 'patologia-superior',
    link: '/disciplinas/patologia-superior',
  },
  {
    label: 'Farmacologia',
    slug: 'farmacologia-superior',
    link: '/disciplinas/farmacologia-superior',
  },
];

export const disciplinesWhiteList = [
  'biologia',
  'quimica',
  'fisica',
  'matematica',
  'historia',
  'geografia',
  'atualidades',
  'filosofia',
  'sociologia',
  'portugues',
  'literatura', 
  'redacao',
  'ingles',
  'espanhol',
  'interdisciplinar',
  'bioquimica-superior',
  'anatomia-superior',
  'histologia-humana-superior',
  'fisiologia-superior',
  'genetica-superior',
  'embriologia-superior',
  'imunologia-superior',
  'microbiologia-superior',
  'parasitologia-superior',
  'patologia-superior',
  'farmacologia-superior',
];

export const getActiveItem = (array: any, slug: string, type: string) => {
  if (array && array.length) {
    const activeItem = array.find((it: any) => it.slug === slug);

    const item = { slug: '', title: '' };

    if (!activeItem) {
      return null;
    }

    if (type === 'static') {
      item.slug = activeItem.slug;
      item.title = activeItem.label;
    } else {
      item.slug = activeItem.slug;
      item.title = activeItem.title;
    }

    return item;
  }

  return null;
};

export const verifyActual = (contentType: string, subjectInfo: ISubject | null) => {
  if(contentType && subjectInfo) {
    if(contentType === 'videoaula') {
      return subjectInfo?.lessonsCount && subjectInfo?.lessonsCount > 0;
    }
    if(contentType === 'exercicio') {
      return subjectInfo?.exerciseCount && subjectInfo?.exerciseCount > 0;
    }
    if(contentType === 'material') {
      return subjectInfo?.materialCount && subjectInfo.materialCount > 0;
    }
    if(contentType === 'podcast') {
      return subjectInfo?.podcastsCount && subjectInfo.podcastsCount > 0;
    }
  }
};

export const firstWithContent = (subjectInfo: ISubject | null, contentType: string, actualType?: boolean | number) => {
  if(actualType) {
    return contentType;
  }

  if(subjectInfo?.lessonsCount && subjectInfo?.lessonsCount > 0) {
    return 'videoaula'
  }

  if(subjectInfo?.exerciseCount && subjectInfo?.exerciseCount > 0) {
    return 'exercicio'
  }
  
  if(subjectInfo?.materialCount && subjectInfo?.materialCount > 0) {
    return 'material'
  }

  if(subjectInfo?.podcastsCount && subjectInfo?.podcastsCount > 0) {
    return 'podcast'
  }
  
  return contentType;
}